module.exports = __webpack_public_path__ + "img/supportBlack.43a36c43.svg";